import { render, staticRenderFns } from "./stack.vue?vue&type=template&id=161a6fd4&scoped=true"
import script from "./stack.vue?vue&type=script&lang=js"
export * from "./stack.vue?vue&type=script&lang=js"
import style0 from "./stack.vue?vue&type=style&index=0&id=161a6fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a6fd4",
  null
  
)

export default component.exports